import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "onClick"]

import { defineAsyncComponent } from 'vue';

import { DKGenericPageContentFragmentsItem } from '@/models/DKGenericPageContentFragmentsItem';

interface Props {
  fragments: DKGenericPageContentFragmentsItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericPageRenderer',
  props: {
    fragments: {}
  },
  setup(__props: any) {

const DKContactFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "contact-fragment" */ '@/components/content-fragments/DKContactFragment.vue'
    )
);
const DKEventOverviewFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "event-overview-fragment" */ '@/components/content-fragments/DKEventOverviewFragment.vue'
    )
);
const DKStockChartFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "stock-chart-fragment" */ '@/components/content-fragments/DKStockChartFragment.vue'
    )
);
const DKReportFilterFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "report-filter-fragment" */ '@/components/content-fragments/DKReportFilterFragment.vue'
    )
);
const DKGenericContentFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "generic-content-fragment" */ '@/components/content-fragments/DKGenericContentFragment.vue'
    )
);
const DKPortfolioFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "portfolio-fragment" */ '@/components/content-fragments/DKPortfolioFragment.vue'
    )
);
const DKMediaGalleryFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "media-gallery-fragment" */ '@/components/content-fragments/DKMediaGalleryFragment.vue'
    )
);
const DKManagementListFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "management-list-fragment" */ '@/components/content-fragments/DKManagementListFragment.vue'
    )
);
const DKGeneralMeetingFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "general-meeting-fragment" */ '@/components/content-fragments/DKGeneralMeetingFragment.vue'
    )
);
const DKPageTeaserFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "page-teaser-fragment" */ '@/components/content-fragments/DKPageTeaserFragment.vue'
    )
);
const DKTeaserFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "teaser-fragment" */ '@/components/content-fragments/DKTeaserFragment.vue'
    )
);
const DKTeaserListFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "teaser-list-fragment" */ '@/components/content-fragments/DKTeaserListFragment.vue'
    )
);
const DKCtaFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "cta-fragment" */ '@/components/content-fragments/DKCtaFragment.vue'
    )
);
const DKShortiesFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "shorties-fragment" */ '@/components/content-fragments/DKShortiesFragment.vue'
    )
);
const DKVideoFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "video-fragment" */ '@/components/content-fragments/DKVideoFragment.vue'
    )
);
const DKContactGroupFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "contact-group-fragment" */ '@/components/content-fragments/DKContactGroupFragment.vue'
    )
);
const DKProductDeclarationFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "product-declaration-fragment" */ '@/components/content-fragments/DKProductDeclarationFragment.vue'
    )
);
const DKNewsletterSignUpFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "newsletter-sign-up-fragment" */ '@/components/content-fragments/DKNewsletterSignUpFragment.vue'
    )
);
const DKGenericShelfFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "generic-shelf-fragment" */ '@/components/content-fragments/DKGenericShelfFragment.vue'
    )
);
const DKNewsOverviewFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "news-overview-fragment" */ '@/components/content-fragments/DKNewsOverviewFragment.vue'
    )
);
const DKFactListFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "fact-list-fragment" */ '@/components/content-fragments/DKFactListFragment.vue'
    )
);
const DKLatestNewsFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "latest-news-fragment" */ '@/components/content-fragments/DKLatestNewsFragment.vue'
    )
);
const DKGenericAccordionFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "generic-accordion-fragment" */ '@/components/content-fragments/DKGenericAccordionFragment.vue'
    )
);
const DKSustainabilityStrategyGraphicFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "sustainability-strategy-graphic-fragment" */ '@/components/content-fragments/DKSustainabilityStrategyGraphicFragment.vue'
    )
);

const DKUseCaseOverviewFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "use-case-overwiew-fragment" */ '@/components/content-fragments/DKUseCaseOverviewFragment.vue'
    )
);

const DKIFrameFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "iframe-fragment" */ '@/components/content-fragments/DKIFrameFragment.vue'
    )
);

const DKHtmlCodeFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "html-code-fragment" */ '@/components/content-fragments/DKHtmlCodeFragment.vue'
    )
);

const DKLatestBlogArticlesFragment = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "latest-blog-articles-fragment" */ '@/components/content-fragments/DKLatestBlogArticlesFragment.vue'
    )
);



const components = {
  DKContactFragment,
  DKContactGroupFragment,
  DKCtaFragment,
  DKEventOverviewFragment,
  DKFactListFragment,
  DKGeneralMeetingFragment,
  DKGenericContentFragment,
  DKGenericShelfFragment,
  DKLatestNewsFragment,
  DKManagementListFragment,
  DKMediaGalleryFragment,
  DKNewsletterSignUpFragment,
  DKNewsOverviewFragment,
  DKPageTeaserFragment,
  DKPortfolioFragment,
  DKProductDeclarationFragment,
  DKReportFilterFragment,
  DKShortiesFragment,
  DKStockChartFragment,
  DKSustainabilityStrategyGraphicFragment,
  DKTeaserFragment,
  DKTeaserListFragment,
  DKVideoFragment,
  DKGenericAccordionFragment,
  DKUseCaseOverviewFragment,
  DKIFrameFragment,
  DKHtmlCodeFragment,
  DKLatestBlogArticlesFragment,
};

const teaserComponents = {
  DKPageTeaserFragment,
  DKTeaserFragment,
  DKTeaserListFragment,
};

const getComponentType = (
  fragment: DKGenericPageContentFragmentsItem
): string | null => {
  const key = 'DK' + fragment.__typename;
  if (!components) {
    return null;
  }

  return components[key] && !teaserComponents[key] ? components[key] : null;
};

const getTeaserComponentType = (
  fragment: DKGenericPageContentFragmentsItem
): string | null => {
  const key = 'DK' + fragment.__typename;
  return teaserComponents[key] ? teaserComponents[key] : null;
};

const getFragmentClass = (
  fragment: DKGenericPageContentFragmentsItem
): string | undefined =>
  fragment.__typename
    ?.split(/(?=[A-Z])/)
    .join('-')
    .toLowerCase();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fragments, (fragment) => {
    return (_openBlock(), _createElementBlock("section", {
      key: fragment.id,
      id: _ctx.$getSectionHashId(fragment.shortTitle),
      class: _normalizeClass(getFragmentClass(fragment)),
      onClick: ($event: any) => (_ctx.$trackFragment($event, fragment))
    }, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (getComponentType(fragment))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentType(fragment)), {
                key: 0,
                fragment: fragment
              }, null, 8, ["fragment"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024)),
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          (getTeaserComponentType(fragment))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(getTeaserComponentType(fragment)), {
                key: 0,
                fragment: fragment
              }, null, 8, ["fragment"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024))
    ], 10, _hoisted_1))
  }), 128))
}
}

})